'use strict';

angular.module('youth').directive('msBackgroundBlur', [function () {
  return {
    templateUrl: 'youth/templates/background-blur.html',
    replace: true,
    restrict: 'A',
    scope: {
      msBackgroundBlur: '='
    },
    link: function link(scope, ele) {
      scope.$watch('msBackgroundBlur', function () {
        ele[0].getContext('2d').fillRect(0, 0, 100, 100);
        if (scope.msBackgroundBlur) {
          var img = new Image();
          img.src = scope.msBackgroundBlur;
          img.onload = function () {
            ele[0].getContext('2d').drawImage(img, 0, 0, 100, 100);
          };
        }
      });
    }
  };
}]);